import {years, monthNames, monthsForYear, tableSpec, translateProfession, translateTransport, translateGender, translateReason, countrySpanishToEnglish} from './tables.js'
import _ from 'lodash'
import PData from './pData.js'
import { charts } from './charts.js'

//----------------------------------------------------------------------------
//----------------------------------------------------------------------------
let numberWithCommas = function(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}

//----------------------------------------------------------------------------
//----------------------------------------------------------------------------
let addIfUniqueIn = function(x,arr) {if (arr.indexOf(x) < 0) arr.push(x)}

//----------------------------------------------------------------------------
//----------------------------------------------------------------------------
let combinedLabels = function(fieldName) {
  var ret = []
  _.forEach(years, function(year) {
    let d1 = PData[year];
    if (d1) {
      let d2 = d1.all;
      if (d2) {
        let d3 = d2[fieldName];
        if (d3) {
          d3.forEach(function(pair) {addIfUniqueIn(pair[0], ret)})
        } else {
          console.log('ERROR: combinedLabels PData[' + year + '].all[' + fieldName + '] is null');
        }
      } else {
        console.log('ERROR: combinedLabels PData['+year+'].all is null');
      }
    } else {
      console.log('ERROR: combinedLabels PData['+year+'] is null');
    }
  })
  return ret
}

//----------------------------------------------------------------------------
//----------------------------------------------------------------------------
let recomputePane = function(paneName, caminoName) {
  if (paneName === 'home') return [[], []];
  let currentOption = tableSpec[paneName];
  //console.log('recomputePane: currentOption=tableSpec['+paneName+']', currentOption)

  //--------------------------------------------------------------------------
  //--------------------------------------------------------------------------
  var isMonthOption = (currentOption.tag==='by-month')
  var isByAge = (currentOption.tag==='by-age')

  //--------------------------------------------------------------------------
  // Generate the contents of all the cells
  //
  // NOTE: We will generate the cell content one column at a time and then, at
  // the end, transpose the cell matrix. It is simpler to do this the way we
  // present the data, which is, years across the columns and categories down the rows
  //--------------------------------------------------------------------------
  var cells = []
  var graphNumberData = []
  var graphPercentData = []

  let labels = [];
  let field = currentOption.field;
  if (field) {
    labels = isMonthOption ? monthNames : combinedLabels(field)
  } else {
    console.log('ERROR: recomputePane: field missing for pane "'+paneName+'"')
  }

  if (isByAge) {
    // Rearrange so that "< 30" is first
    var temp = labels[1]
    labels[1] = labels[0]
    labels[0] = temp
  }

  //function addNBSPtoY(s) {return s.replace(' y ', '&nbsp;y ')}
  //function addNBSPtoAmpersand(s) {return s.replace(' & ', '&nbsp;&amp; ')}
  function removeDashs(s) {return s.replace(' - ', '- ')}

  // first do the column of labels on the left side.
  // since we are transposing later this starts as the first row.

  var currentRow = [currentOption.title, 'All']
  var currentNumberRow = ['All']
  var currentPercentRow = ['All']
  var translation
  _.forEach(labels, function(label) {
    let printLabel = removeDashs(label)
    let graphLabel = printLabel; //.replace('&nbsp;', ' ')

    // Translate labels
    switch (currentOption.tag) {
      case "by-transport":
      translation = translateTransport[label]
      if (translation) printLabel = translation
      break;
      case "by-gender":
      translation = translateGender[label]
      if (translation) printLabel = translation
      break;
      case "by-profession":
      translation = translateProfession[label]
      if (translation) printLabel = translation
      break;
      case "by-age":
      if (printLabel==='30- 60') {
        // Use a non-breaking hyphen
        printLabel = '30 to 60'
        graphLabel = '30-60'
      }
      break;
      case "by-country":
      translation = countrySpanishToEnglish[label]
      if (translation) printLabel = translation
      break;
      case "by-starting-city":
      break;
      case "by-starting-region":
      break;
      case "by-reason":
      translation = translateReason[label]
      if (translation) printLabel = translation
      else console.log('missing reason: '+label)
      break;
      default:
      case "spanish-by-region":
      break;
    }
    currentRow.push(printLabel)
    currentNumberRow.push(graphLabel)
    currentPercentRow.push(graphLabel)
  })
  cells.push(currentRow)
  graphNumberData.push(currentNumberRow)
  graphPercentData.push(currentPercentRow)

  //--------------------------------------------------------------------------
  //--------------------------------------------------------------------------

  // NOTE: later change this to '2004-2018'
  // LATER: make these changes more automated

  var extendedYears = years;
  if (!isMonthOption) {
    extendedYears = ['2004-2017'].concat(years)
  }

  //--------------------------------------------------------------------------
  // Do each of the years.
  //--------------------------------------------------------------------------

  _.forEach(extendedYears, function(year) {
    currentRow = []
    currentNumberRow = []
    currentPercentRow = []

    var yearLabel = '' + year
    if (year==='2018') yearLabel += ' (1-2)'

    if (year==='2004-2017') yearLabel = '2004-2017'
    currentRow.push(yearLabel)
    currentNumberRow.push(yearLabel)
    currentPercentRow.push(yearLabel)

    let getCaminoTotal = o => {
      let pair = o['caminos'].find(p=>p[0]===caminoName);
      if (!pair) {
        console.log('**** camino not found=', o['caminos']);
        return 88;
      } else {
        return pair[1];
      }
    }

    let yall =  PData[year]
    if (!yall) {
      console.log('PData['+year+']')
    }
    var yearTotal = PData[year]['all'].pilgrims;
    if (paneName==='completions' && caminoName!=='All') {
      yearTotal = getCaminoTotal(PData[year]['all'])
    }
    currentRow.push(numberWithCommas(yearTotal))
    var keys = labels
    if (isMonthOption) {
      keys = monthsForYear(year)
    }

    _.forEach(keys, function(key) {
      var keyValue = 9999
      if (isMonthOption) {
        if (paneName==='completions' && caminoName!=='All') {
          keyValue = getCaminoTotal(PData[year][key])
        } else {
          let val = 88;
          if (PData[year]) {
            if (PData[year][key]) {
              val = PData[year][key].pilgrims
            } else {
              console.log('PData['+year+']['+key+'] undefined')
            }
          } else {
            console.log('PData['+year+'] undefined')
          }
          keyValue = val;
        }
      } else {
        var pair = _.find(PData[year]['all'][currentOption.field], function(p) {return p[0]===key})
        keyValue = pair ? pair[1] : 0;
      }
      var cellPercent = Math.round(100*keyValue/yearTotal)
      var cellValue = (!keyValue) ? ' ' : numberWithCommas(keyValue) +  ' ' + cellPercent.toFixed(0) + '%';
      currentRow.push(cellValue)
      currentNumberRow.push(keyValue)
      currentPercentRow.push(cellPercent)
    })
    cells.push(currentRow)
    graphNumberData.push(currentNumberRow)
    graphPercentData.push(currentPercentRow)
  })

  // Transpose the array of equal-length arrays, a matrix
  cells = _.zip.apply(_, cells)

  let allCharts = charts(paneName, graphPercentData, graphNumberData);

  return [cells, allCharts];

}

  export {recomputePane};
  /*
  PData: {2004, 2005, 2006, 2007, 2008, 2009, 1010, 2011, 2012, 2013, 2014, 2015, 2016, 2004-2017} (+ 2018 only has 1-1)
  -- Pdata.2016: {all, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12}
  -- Pdata.2016.5: (
  -- Note: array counts may differ as 0-count items are not there.
  age: Array[3]: [label,count]
  byCountry: Array[81]: [label,count]
  caminos: Array[8]: [label,count]
  gender: Array[2]: [label,count]
  month:"5"
  motivation: Array[3]: [label,count]
  pilgrims: 19803
  professions: Array[18]: [label,count]
  spanishFrom: Array[20]: [label,count]
  startingCities: Array[134]: [label,count]
  startingRegions: Array[43]: [label,count]
  transport: Array[4]: [label,count]
  year: "2011"
  )
  */



// WEBPACK FOOTER //
// ./src/computePane.js